import { render, staticRenderFns } from "./ComInput.vue?vue&type=template&id=031a18a0&scoped=true&"
import script from "./ComInput.vue?vue&type=script&lang=js&"
export * from "./ComInput.vue?vue&type=script&lang=js&"
import style0 from "./ComInput.vue?vue&type=style&index=0&id=031a18a0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031a18a0",
  null
  
)

export default component.exports